import EtfInstrumentIcon from './EtfInstrumentIcon';

export default EtfInstrumentIcon;
